import React from 'react';
import Breadcrumbs, { BreadcrumbGoToAnchor, BreadcrumbLink, LocationBreadcrumbs } from '../../generic/Breadcrumbs';
import { useSections } from '../TocContext';
import styles from './index.module.scss';

export function Toc({ heading, workspaceLink }) {
  let { sectionsValues } = useSections();

  return (
    <Breadcrumbs className={styles.tocList}>
      <LocationBreadcrumbs>
        <BreadcrumbLink to="/workspaces">Workspaces</BreadcrumbLink>
        <BreadcrumbLink to={workspaceLink}>{heading}</BreadcrumbLink>
      </LocationBreadcrumbs>
      {sectionsValues.map(({ title, id }) => {
        return (
          <BreadcrumbGoToAnchor key={id} id={id}>
            {title}
          </BreadcrumbGoToAnchor>
        );
      })}
    </Breadcrumbs>
  );
}
